import type { MouseEvent } from 'react';

const withStopPropagation = (handler?: (event?: MouseEvent) => void) => (event?: MouseEvent) => {
  event?.stopPropagation();
  handler?.(event);
};

export default withStopPropagation;
